import { Component, Input, inject } from '@angular/core';
import { SharedService } from '../../Shared/shared-service.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-message-clipboard',
  templateUrl: './message-clipboard.component.html',
  styleUrl: './message-clipboard.component.scss',
  standalone: false
})
export class MessageClipboardComponent {
  protected sharedService = inject(SharedService);

  @Input() value: string;
  @Input() compareString = "";
  @Input() isModal = false;
  @Input() modalTitle = "";

  activeModal = inject(NgbActiveModal);
  generateWhatsappLink() {
    const encoded = encodeURIComponent(this.value);
    window.open("https://api.whatsapp.com/send?text=" + encoded, "_blank");
  }

  needSplitScreen() {
    if ((this.sharedService.isAdmin() || this.sharedService.isBossAccount()) && this.sharedService.compareResult(this.compareString, this.value) != true)
      return 'col-12 col-md-6 d-none d-md-block';
    else
      return 'col-12';
  }

  formatString(string: string) {
    return string.replace("*", "");
  }

  reset() {
    this.activeModal.close();
  }

}
